 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		25: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"npm.quill","2":"npm.react-dom","3":"npm.react-quill","7":"npm.babel","8":"npm.emoji-picker-react","9":"npm.react-dd-menu","10":"npm.react-papaparse","11":"npm.react-player","12":"npm.readable-stream","17":"npm.canvg","18":"npm.create-react-class","19":"npm.d3-scale","20":"npm.dompurify","21":"npm.react-querybuilder","22":"npm.react-smooth","23":"npm.react-sortable-hoc","24":"npm.recharts"}[chunkId]||chunkId) + "." + {"1":"d603068026ac191700d3","2":"0e7c69ea3084e053b6a2","3":"178c407a689716bef2cb","4":"bd6e356416e16e6e78b4","5":"170ac1aaeda3ea71f59e","6":"b60353fe52070d422928","7":"f53aa471d5fd48bd2f25","8":"60e8a3c3d4500ffdf1b4","9":"091a8b7bab5aa73ee718","10":"c474607377a9ed04d054","11":"f51a5adafe29531e67fc","12":"ca130e96103a05dd5f36","13":"b96ba9bf7b6a5eff59eb","14":"1b625f3378a9db60bbef","17":"23abe43bec6ee4a4ccb2","18":"4d17f9c1570e999f6e9d","19":"f35c3202dd6e26f0654c","20":"01f21c1fa07c5237801c","21":"5958492da9d50145e70e","22":"8bdea132b417f5b65922","23":"3176a1410e1709acb014","24":"608993608670a53be41c","26":"912397038b0923a6b76a","27":"6dcbf400d13154a56f4d","28":"a2618ef1287df6052383","29":"434ad9cfe489ad3ada35","30":"5df479fd0776e9bf2465","31":"ad31f1442f62b1413b22","32":"13c9cd1a8e565a359789","33":"51d125671c790fd60b01","34":"889f13bcbfc4d009a1be","35":"5d6330c03b723c397e72","36":"d9b16234acef05180ae7","37":"c00843de4651e851fa13","38":"71e57a3887e1f994fd54","39":"3b2f662819e54ae4f218","40":"1c89e1d8e55d06308f8d","41":"62a4cf547f9ec5be1f54","42":"23891316f2b29591cdc8","43":"c08995bbd2028d062ae2","44":"bbf5fff71aa7fd6d7344","45":"da803fcf2d07b0219fed","46":"17f5b79c92fb204e5843","47":"c5d566e45771840f42ad","48":"4bbee5926680d3dca4aa","49":"1e4751a69f90bf17dab5","50":"afe0a0e05fbb1b5f9693","51":"ed6e2cd061ff7507fd45","52":"bc420944a5accd014b38","53":"5948fb083a49c6adb3cc","54":"fbdfb95be25a06cad4a9","55":"6479f6117fc0fd71d1ae","56":"ae958cd59811467be283","57":"36f54b95a6b6da60ae43","58":"ded87debc732b20a4880","59":"dae50f6d60f8d4f117a0","60":"e8585c4c49f2ea859d54","61":"5bdf6675a0446f30035d","62":"5865f0210e83e747be1d","63":"4b5cb39e92f0faadaeec","64":"e957101bd040c32e7fbb","65":"182a2024f75fef02b231","66":"bb2562c2a236a5c5c2e0","67":"fd78fea5829250ca0342","68":"aa93f6de89348fb82f96","69":"2739f6e6051514d54bbd","70":"0f3f52d7f88cfc5a35b3","71":"e2e7b4867b77aff18974","72":"9c3cbf454a8886920c66","73":"031aeb47afbd29e56c45","74":"8c5ed52d1762ea73fa03","75":"cfa090bdda7e068a9384","76":"b67d4ab02d705cb83bea","77":"d178e1bec8a501e039ba","78":"a490a4acace238e09770","79":"7ba1566c443dd067d132","80":"7638de1ae2dc9c91a966","81":"04f2252f0ffbd7a0c000","82":"f091432d68a837ce1b85","83":"7047e58c89a94e0f232f","84":"10eb92e0b641c7d1c629","85":"14675fe2041911f3ae44","86":"d0214f6409d111cd7dc8","87":"157d13d1edbdb0bb584b","88":"0fc151bc81b9ec311cfd","89":"80b027c82bbd710e8825","90":"102c728865c097a57c05","91":"b98d474a00e2ab0e48d3","92":"29bb63885033cfb9c777"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/227baa6/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
